<app-acknowledgement>
  <mat-card class="hotelDetails">
    <section class="sectionWrapper">
      <ng-container *ngIf="list as item">
        <div class="wrapper">
          <div class="innerWrapper">
            <h3 class="hotelName">{{item.property_details.name | titlecase}}</h3>
            <p class="location">
              <mat-icon color="primary">location_on</mat-icon>{{item.property_details.location.address}} {{item.property_details.location.city.name}}, <span *ngIf="item.property_details.location.country.name !== null">{{item.property_details.location.country.name}}</span> {{item.property_details.location.zip_code}}
            </p>
            <div class="checkINOut">
              <p>Check-in: <span>{{item.booking_details.checkin_date | date: 'fullDate'}}</span></p>
              <p>Check-out: <span>{{item.booking_details.checkout_date | date: 'fullDate'}}</span></p>
            </div>
            <div class="guestBed">
              <p>
                <mat-icon>person</mat-icon>{{item.booking_details.no_adult + item.booking_details.no_children}} Guests
              </p>
              <p>
                <mat-icon>king_bed</mat-icon>{{item.booking_details.no_room}} Room<span *ngIf="item.booking_details.no_room > 1">s</span>&nbsp;({{item.room_details[0].room_name | titlecase}})
              </p>
            </div>
            <!-- <p class="noTravel">No. of Travelers<span>{{item.booking_details.no_adult + item.booking_details.no_children}}</span></p> -->
            <!-- <p class="room"> <span>X&nbsp;&nbsp;&nbsp;{{item.booking_details.no_room}}</span></p> -->
          </div>
          <div class="innerWrapper">
            <div class="wrapperImg">
              <img *ngIf="item.property_details.property_images.length === 0" src="../../../../assets/b2c/hotel/hotel_dummy.png" alt="" class="img-fluid">
              <ng-container *ngIf="item.property_details.property_images.length !== 0">
                <img [src]="item.property_details.property_images[0].image_path" alt="" class="img-fluid">
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
    </section>
    <section class="sectionWrapper">
      <h3 class="title">Travelers Details</h3>
      <div class="pessangerList">
        <ul>
          <li *ngFor="let item of list['customer_details']; last as last">
              <p><strong>{{item.salutation | titlecase }}. {{item.first_name | titlecase}} {{item.last_name | titlecase}}</strong></p>
              <p>{{item.telephone}}</p>
              <p>{{item.email}}</p>
              <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
          </li>
        </ul>
        <p><strong>Address:</strong>&nbsp;&nbsp;{{list.customer_details[0].address}}&nbsp;{{list.customer_details[0].city}}&nbsp;{{list.customer_details[0].country}}&nbsp;{{list.customer_details[0].zip}}</p>
      </div>
    </section>
    <section class="sectionWrapper">
      <h3 class="title">Summary</h3>
      <div class="summaryList">
        <ng-container *ngIf="list as item">
          <mat-list>
            <mat-list-item>
              <p><span>
                <mat-icon>king_bed</mat-icon>&nbsp;{{item.booking_details.no_room}} Rooms
              </span><span>{{item.price_details.base_price | currency : 'INR' }}</span></p>
            </mat-list-item>
            <mat-list-item *ngIf="item.booking_details.tax !== '0'">
              <p>Taxes<span>{{item.price_details.tax_amount | currency : 'INR' }}</span></p>
            </mat-list-item>
            <mat-list-item>
              <p class="discount">Discount<span>-{{item.price_details.discount | currency : 'INR' }}</span></p>
            </mat-list-item>
            <mat-list-item>
              <p>Grand Total<span>{{item.price_details.total_price | currency : 'INR' }}</span></p>
            </mat-list-item>
          </mat-list>
        </ng-container>
        </div>
    </section>
  </mat-card>
  <!-- <mat-card class="hotelDetails searchDetails">
    <section class="sectionWrapper">
      <h2 class="titleHeading">Locate us on Map</h2>
      <div class="wrapper">
        <div class="innerWrapper">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.1730718172234!2d77.04909801552888!3d28.59458428243276!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1b271fdeece1%3A0x9fe8a0d411dd0204!2sBelair%20Ticket%20Centre!5e0!3m2!1sen!2sin!4v1652693395819!5m2!1sen!2sin"
            width="100%" height="420" style="border:0;" allowfullscreen="" loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
        <div class="innerWrapper">
          <mat-card>
            <div class="information">
              <h4>Need assistance?</h4>
              <p>Call <a href="tel:+911142521000">+91 11 42521000</a> (9 AM - 6 PM IST Mon-Fri)</p>
              <h5>Why Book With Us</h5>
              <ul>
                <li>
                  <img src="../../../assets/main/refund.png" alt="" class="img-fluid">
                  <div class="content">
                    <h5>7 Day ‘Change of Mind’ Refund</h5>
                    <p>Get a full refund, no questions asked.</p>
                  </div>
                </li>
                <li>
                  <img src="../../../assets/main/guarantee.png" alt="" class="img-fluid">
                  <div class="content">
                    <h5>Best Price Guarantee</h5>
                    <p>Found a better price? We’ll match it… and more.</p>
                  </div>
                </li>
                <li>
                  <img src="../../../assets/main/quality.png" alt="" class="img-fluid">
                  <div class="content">
                    <h5>VIP Quality</h5>
                    <p>We test the beds to ensure it’s the world’s best.</p>
                  </div>
                </li>
              </ul>
            </div>
          </mat-card>
        </div>
      </div>
    </section>
  </mat-card> -->
  <mat-card class="hotelDetails aboutSection" *ngIf="list.property_details.overview !== null">
    <div class="sectionWrapper">
      <div class="heading">
        <h2 class="titleHeading">About {{list.property_details.name | titlecase}}</h2> <!-- Hotel Name -->
        <button mat-button color="primary" (click)="viewMore = !viewMore">{{ viewMore ? 'View less': 'View More' }}<mat-icon>{{ viewMore ? 'expand_less': 'expand_more' }}</mat-icon></button>
      </div>
      <div class="content" [class.viewMore]="viewMore">
        <p>{{list.property_details.overview}}</p>
      </div>
    </div>
  </mat-card>
  <ng-container *ngIf="list as item">
    <mat-card class="hotelDetails hotelPolicy" *ngIf="showPolicy">
      <section class="sectionWrapper">
        <h2 class="titleHeading">Hotel Guidelines and Cancellation Policy</h2>
        <div class="hotelPolicyDetails">
          <p>{{item.room_details.cancellation_policy}}</p>
        </div>
      </section>
    </mat-card>
  </ng-container>
</app-acknowledgement>
